/** Relevance-score tier cutoffs (0–100). HIGH = green/"strongly relevant",
 *  the threshold the corpus already uses for top-tier scoring. */
export const SCORE_TIER_HIGH = 75;
export const SCORE_TIER_MID = 50;
